export default "__VITE_ASSET__DVpq3J9a__"